module.exports = __webpack_public_path__ + "static/media/white.b7815641.png";